<template>
  <div class="container">
    <div class="inner-box">
      <p class="title">
        <span>{{leftList.name}}</span>
        <span @click="toList(leftList.id)">更多</span>
      </p>
      <ul class="list-wrapper">
        <li class="list-item" v-for="item in (leftList.content || '').slice(0, 10)" :key="item.id">
          <span :class="showNew(item.check_time)" @click="toDetail(item.id)"><strong style="font-size: 10px">· </strong>{{item.title | titleFilter}}</span>
          <span class="article-time">{{item.check_time}}</span>
        </li>
      </ul>
    </div>
    <div class="inner-box">
      <p class="title">
        <span>{{middleList.name}}</span>
        <span @click="toList(middleList.id)">更多</span>
      </p>
      <ul class="list-wrapper">
        <li class="list-item" v-for="item in (middleList.content || '').slice(0, 10)" :key="item.id">
          <span :class="showNew(item.check_time)" @click="toDetail(item.id)"><strong style="font-size: 10px">· </strong>{{item.title | titleFilter}}</span>
          <span class="article-time">{{item.check_time}}</span>
        </li>
      </ul>
    </div>
    <div class="inner-box">
      <p class="title">
        <span>{{rightList.name}}</span>
        <span @click="toList(rightList.id)">更多</span>
      </p>
      <ul class="list-wrapper">
        <li class="list-item" v-for="item in (rightList.content || '').slice(0, 10)" :key="item.id">
          <span :class="showNew(item.check_time)" @click="toDetail(item.id)"><strong style="font-size: 10px">· </strong>{{item.title | titleFilter}}</span>
          <span class="article-time">{{item.check_time}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Beijing',
  props: {
    beijingList: {
      type: Object,
      required: true
    }
  },
  filters: {
    titleFilter (title) {
      return title.replace(/<br \/>/, '')
    }
  },
  watch: {
    beijingList: function (data) {
      if (!data) {
        return
      }
      this.leftList = data.leftList[0]
      this.middleList = data.middleList[0]
      this.rightList = data.rightList[0]
      // this.leftTitle = data.leftList[0].name
      // this.middleTitle = data.middleList[0].name
      // this.rightTitle = data.rightList[0].name
    }
  },
  data () {
    return {
      leftList: [],
      middleList: [],
      rightList: []
    }
  },
  methods: {
    showNew (time) {
      const str = time.replace(/-/g, '/')
      const createTime = new Date(str)
      const date = new Date()
      // 三天内
      if (createTime.getTime() <= date.getTime() && date.getTime() <= (createTime.getTime() + 259200000)) {
        return 'article-title new'
      }
      return 'article-title'
    },
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    toDetail (id) {
      this.$router.push(`/content/${id}`)
    }
  }
}
</script>

<style scoped>

@keyframes text {
  0%{
    color: red;
  }
  50%{
    color: pink;
  }
  100%{
    color: red;
  }
}
  .container {
    width: 1180px;
    height: 374px;
    display: flex;
    justify-content: space-between;
  }

  .inner-box {
    width: 32%;
    height: 100%;
    box-shadow: 1px 1px 4px #ccc;
    border: 1px solid #ccc;
    overflow: hidden;
  }

  .inner-box .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 40px;
    padding: 0 8px;
    border-bottom: 1px solid #cccccc;
  }

  .inner-box .title span:first-child {
    box-sizing: border-box;
    font-weight: 700;
    color: rgb(1, 142, 214);
    font-size: 18px;
  }

  .inner-box .title span:last-child {
    font-size: 12px;
    color: #cccccc;
  }

  .inner-box .title span:last-child:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .list-item {
    padding: 10px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .article-title {
    /*width: 70%;*/
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    position: relative;
    box-sizing: border-box;
    padding-right: 40px;
  }

  .new:after{
    content: 'New';
    position: absolute;
    color: #333333;
    font-size: 10px;
    right: 3px;
    padding: 3px 5px;
    border-radius: 3px;
    margin-left: 3px;
    animation: text 2s;
    animation-iteration-count: infinite;
  }

  .list-item:hover {
    color: rgb(1, 142, 214);
    cursor: pointer;
  }

  .article-time {
    color: #888888;
    font-size: 13px;
    position: relative;
    display: flex;
    flex-shrink: 0;
  }

  .more {
    cursor: pointer;
  }
</style>
